
<div class="w-full flex flex-col justify-center items-center contact-us-main-container">
  <validation-observer
    class="w-full max-w-[1216px]"
    tag="form"
    ref="validation"
    v-slot="{ invalid }"
    @submit.prevent="handleSubmit"
  >
    <div class="flex flex-col justify-between 1170-bp:flex-row gap-2 1170-bp:gap-5">
      <div class="w-full field">
        <label class="contact-us-label">First Name <span class="">*</span></label>
        <div class="control mt-1.5">
          <validated-input v-model="lead.firstName" name="First name" page="contact-us" rules="required" />
        </div>
      </div>
      <div class="w-full field">
        <label class="contact-us-label">Last Name <span class="">*</span></label>
        <div class="control mt-1.5">
          <validated-input v-model="lead.lastName" name="Last name" page="contact-us" rules="required" />
        </div>
      </div>
      <div class="w-full field hide-below-1441">
        <label class="contact-us-label">Email <span class="">*</span></label>
        <div class="control mt-1.5">
          <validated-input v-model="lead.email" name="Email" page="contact-us" rules="required|email" />
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-between 1170-bp:flex-row gap-2 1170-bp:gap-5">
      <div class="w-full field hide-above-1440">
        <label class="contact-us-label">Email <span class="">*</span></label>
        <div class="control mt-1.5">
          <validated-input v-model="lead.email" name="Email" page="contact-us" rules="required|email" />
        </div>
      </div>
      <div class="w-full field">
        <label class="contact-us-label">Phone <span class="">*</span></label>
        <div class="control mt-1.5">
          <validated-input
            v-model="lead.phone"
            name="Phone number"
            page="contact-us"
            :rules="{ required: true, regex: /^\+?[0-9()-]*$/ }"
          />
        </div>
      </div>
      <div class="w-full field hide-below-1441">
        <label class="contact-us-label required">Zip Code <span class="">*</span></label>
        <div class="mt-1.5">
          <validated-input
            v-model="lead.zipcode"
            name="Delivery zip"
            page="contact-us"
            icon="zipCode"
            :rules="{ required: true, regex: /^\d{5}$|^\d{5}-\d{4}$/ }"
          />
        </div>
      </div>

      <div class="w-full field hide-below-1441">
        <label class="contact-us-label">Rental or Purchase</label>
        <div class="control mt-1.5">
          <div class="button-group">
            <button
              type="button"
              :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Sale' }]"
              @click="lead.data.purchaseType = 'Sale'"
            >
              Buy
            </button>
            <button
              type="button"
              :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Rental' }]"
              @click="lead.data.purchaseType = 'Rental'"
            >
              Rent
            </button>
            <button
              type="button"
              :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Not Sure' }]"
              @click="lead.data.purchaseType = 'Not Sure'"
            >
              Don't know
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-between 1170-bp:flex-row gap-2 1170-bp:gap-5 hide-above-1440">
      <div class="w-full field">
        <label class="contact-us-label required">Zip Code <span class="">*</span></label>
        <div class="mt-1.5">
          <validated-input
            v-model="lead.zipcode"
            name="Delivery zip"
            page="contact-us"
            icon="zipCode"
            :rules="{ required: true, regex: /^\d{5}$|^\d{5}-\d{4}$/ }"
          />
        </div>
      </div>
      
      <div class="w-full field mb-5 1170-bp:mb-5">
        <label class="contact-us-label">Rental or Purchase</label>
        <div class="control mt-1.5">
          <div class="button-group">
            <button
              type="button"
              :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Sale' }]"
              @click="lead.data.purchaseType = 'Sale'"
            >
              Buy
            </button>
            <button
              type="button"
              :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Rental' }]"
              @click="lead.data.purchaseType = 'Rental'"
            >
              Rent
            </button>
            <button
              type="button"
              :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Not Sure' }]"
              @click="lead.data.purchaseType = 'Not Sure'"
            >
              Don't know
            </button>
          </div>
        </div>
      </div>
    </div>
    
    
    <div>
      <div class="flex flex-col justify-between 1170-bp:flex-row gap-2 1170-bp:gap-5">
        <div class="w-full field">
          <label class="contact-us-label">Company or Organization</label>
          <div class="control mt-1.5">
            <input
              v-model="lead.company"
              type="text"
              aria-required="false"
              class="input contact-us-input"
            />
          </div>
        </div>
        <div class="w-full field mb-5 1170-bp:mb-0">
          <label class="contact-us-label">Quantity</label>
          <div class="control mt-1.5">
            <validated-input v-model="lead.data.quantity" name="Quantity" page="contact-us" rules="integer|min_value:0" />
          </div>
        </div>
      </div>
      <div class="field">
        <label class="contact-us-label">Message (Optional)</label>
        <div class="control mt-1.5">
          <textarea v-model="lead.notes" placeholder="Type your message..." class="textarea contact-us-input h-[343px]" title="Notes" aria-required="false"></textarea>
        </div>
      </div>

      <div class="flex 1440-bp:flex-row flex-col 1440-bp:justify-between 1440-bp:gap-0 gap-2 mb-0 mt-4">
        
        <label class="checkbox flex items-center">
          <input type="checkbox" class="mr-2 filter-checkbox" v-model="lead.smsConsent">
          <b class="contact-us-consent-text">I consent to receive SMS text messages from this business.</b>
        </label>
      
     
        <div class="flex justify-end">
          <button
            :disabled="invalid || loading > 0"
            :class="['w-[155px] h-[44px] border border-[#3565FC] rounded-full bg-[#3565FC] flex justify-center items-center', { 'cursor-not-allowed' : invalid || loading > 0 } ]"
            data-label="submit"
            type="submit"
          >
            <p class="send-message-btn-txt">Send Message</p>
          </button>
        </div>

      </div>
      
    </div>
  </validation-observer>
</div>
